export default __webpack_public_path__ + "static/media/549.cff70a3d.png";